module.exports = __webpack_public_path__ + "static/media/2_Jens_Winter_Zertifikate.dd9020d0.jpg";